"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_PRICING_PERMISSIONS = exports.PricingPermissions = void 0;
/**
 * Permission string catalog for Pricing (Stage 14, Phase 3 — Enterprise
 * Pricing & Commercial Engine). Step 3a: `PriceList` lifecycle + read-only
 * price/batch selection. Step 3b adds Commercial Rule Engine + Contract
 * Pricing. Step 3c adds the Promotion Engine + Discount Engine.
 */
exports.PricingPermissions = {
    PRICE_LIST_READ: 'price-list:read',
    PRICE_LIST_CREATE: 'price-list:create',
    PRICE_LIST_APPROVE: 'price-list:approve',
    PRICE_LIST_ACTIVATE: 'price-list:activate',
    PRICE_LIST_CANCEL: 'price-list:cancel',
    PRICE_OVERRIDE: 'price-list:override',
    PRICE_AUDIT: 'price-list:audit',
    PRICE_SELECT: 'price-list:select',
    COMMERCIAL_RULE_MANAGE: 'commercial-rule:manage',
    CONTRACT_READ: 'contract:read',
    CONTRACT_MANAGE: 'contract:manage',
    PROMOTION_MANAGE: 'promotion:manage',
    DISCOUNT_OVERRIDE: 'discount:override',
};
exports.ALL_PRICING_PERMISSIONS = Object.values(exports.PricingPermissions);
//# sourceMappingURL=pricing.permissions.js.map